import { render, staticRenderFns } from "./CustomContainer.vue?vue&type=template&id=4c5371db&scoped=true&"
import script from "./CustomContainer.vue?vue&type=script&lang=js&"
export * from "./CustomContainer.vue?vue&type=script&lang=js&"
import style0 from "./CustomContainer.vue?vue&type=style&index=0&id=4c5371db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5371db",
  null
  
)

export default component.exports